import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getCurrentUser } from 'ducks/users'

import Users from './Users'
import Apps from './Apps'
import Builds from './Builds'
import { Libraries, Library } from './Marketplace'

const AdminRoutes = () => {
  const user = useSelector(state => getCurrentUser(state))

  // redirect non-admin user
  if (user && !user.admin) return <Redirect to="/" />

  return (
    <Switch>
      <Route
        exact
        path="/admin"
        component={() => <Redirect to="/admin/users" />}
      />
      <Route exact path="/admin/users" component={Users} />
      <Route exact path="/admin/users/:userId" component={Apps} />
      <Route exact path="/admin/marketplace" component={Libraries} />
      <Route
        exact
        path={[
          '/admin/marketplace/:libraryName',
          '/admin/marketplace/:libraryAuthor/:libraryName',
        ]}
        component={Library}
      />
      <Route exact path="/admin/builds" component={Builds} />
    </Switch>
  )
}

export default AdminRoutes
